/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PasswordResetRequest {
    getFixupPrototypeFunction() { return PasswordResetRequest.fixupPrototype; }

    static newInstance(model: Partial<PasswordResetRequest>): PasswordResetRequest {
        let obj = Object.assign(new PasswordResetRequest(), model);
        PasswordResetRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PasswordResetRequest>): PasswordResetRequest {
        if (!model) return null;
        return PasswordResetRequest.newInstance(<PasswordResetRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PasswordResetRequest) {
        if (!obj) return;

        models.PasswordResetRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PasswordResetRequest): boolean {
        Object.setPrototypeOf(obj, PasswordResetRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Set new password
     */
    password: string;

    reset_key: string;

}
